module.exports = __webpack_public_path__ + "img/advent-tree.3b2e47fb.png";